"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.fetchPortalCurrencyInfo = exports.syncROISetting = exports.syncCostPerLead = exports.fetchCostPerLead = void 0;

var _reduxObservable = require("redux-observable");

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _actions = require("./actions");

var _selectors = require("./selectors");

var _API = _interopRequireDefault(require("./API"));

var fetchCostPerLead = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getCostPerLead,
  initiatingActionType: _actions.AdsROIActionTypes.FETCH_COST_PER_LEAD,
  requestStatusSelector: _selectors.getFetchCostPerLeadRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchCostPerLead
}));
exports.fetchCostPerLead = fetchCostPerLead;
var syncCostPerLead = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.syncCostPerLead,
  initiatingActionType: _actions.AdsROIActionTypes.SYNC_COST_PER_LEAD,
  requestStatusSelector: _selectors.getSyncCostPerLeadRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.SyncCostPerLead
}));
exports.syncCostPerLead = syncCostPerLead;
var syncROISetting = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.syncROISetting,
  initiatingActionType: _actions.AdsROIActionTypes.SYNC_ROI_SETTING,
  requestStatusSelector: _selectors.getSyncROISettingRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.SyncROISetting
}));
exports.syncROISetting = syncROISetting;
var fetchPortalCurrencyInfo = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.fetchPortalCurrencyInfo,
  initiatingActionType: _actions.AdsROIActionTypes.FETCH_PORTAL_CURRENCY_INFO,
  requestStatusSelector: _selectors.getFetchPortalCurrencyInfoRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchPortalCurrencyInfo
}));
exports.fetchPortalCurrencyInfo = fetchPortalCurrencyInfo;

var _default = (0, _reduxObservable.combineEpics)(fetchCostPerLead, syncCostPerLead, syncROISetting, fetchPortalCurrencyInfo);

exports.default = _default;